import { useState } from 'react';
import clsx from 'clsx';
import { CashboxList } from './components/CashboxList.jsx';
import { TransfersList } from './components/TransfersList.jsx';

const TABS = [
  { key: 'cashboxes', label: 'القاصات' },
  { key: 'transfers', label: 'التحويلات' }
];

function Tabs({ value, onChange }) {
  return (
    <div className="inline-flex items-center gap-1 p-1 bg-white border border-line rounded-[10px] shadow-card">
      {TABS.map((t) => (
        <button
          key={t.key}
          type="button"
          onClick={() => onChange(t.key)}
          className={clsx(
            'px-3.5 py-1.5 rounded-[8px] text-[12.5px] font-semibold transition-colors',
            value === t.key
              ? 'bg-orange text-white shadow-orange-glow'
              : 'text-ink-2 hover:bg-paper-2'
          )}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}

export function CashboxScreen() {
  const [tab, setTab] = useState('cashboxes');

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="text-xl font-extrabold tracking-tight m-0">القاصات والتحويلات</h2>
          <div className="text-ink-3 text-xs mt-0.5">إدارة القاصات والتحويلات بين الفروع</div>
        </div>
        <Tabs value={tab} onChange={setTab} />
      </div>

      {tab === 'cashboxes' ? <CashboxList /> : null}
      {tab === 'transfers' ? <TransfersList /> : null}
    </div>
  );
}
